import React, { useState, useContext, useEffect } from 'react';
import { AuthContext, API } from '../App';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Eye, EyeOff, Shield } from 'lucide-react';

export default function UltraAdminLogin() {
  const { setUser } = useContext(AuthContext);
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/auth/login`, loginData);
      
      if (res.data.user.role !== 'ultra_admin') {
        toast.error('Bu panel sadece Ultra Admin kullanıcıları içindir');
        return;
      }
      
      localStorage.setItem('token', res.data.access_token);
      setUser(res.data.user);
      toast.success('Giriş başarılı!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Giriş başarısız');
    }
  };

  const handleTestLogin = async () => {
    try {
      // Test login endpoint'ini çağır (şifresiz giriş)
      const res = await axios.post(`${API}/auth/test-login`);
      
      localStorage.setItem('token', res.data.access_token);
      setUser(res.data.user);
      toast.success('Test girişi başarılı!');
      
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Test girişi başarısız');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 p-4">
      <Card className="w-full max-w-md shadow-2xl border-purple-500/20" data-testid="ultra-admin-login-card">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-3xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Ultra Admin Panel
          </CardTitle>
          <CardDescription>Sistem yönetimi ve kontrol paneli</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4" data-testid="ultra-admin-login-form">
            <div className="space-y-2">
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@example.com"
                value={loginData.email}
                onChange={(e) => setLoginData({...loginData, email: e.target.value})}
                required
                data-testid="ultra-admin-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Şifre</Label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={loginData.password}
                  onChange={(e) => setLoginData({...loginData, password: e.target.value})}
                  required
                  data-testid="ultra-admin-password-input"
                  className="pr-10"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  data-testid="toggle-ultra-admin-password"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700" data-testid="ultra-admin-login-btn">
              Panele Giriş Yap
            </Button>
            
            <div className="relative my-4">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-white px-2 text-gray-500">veya</span>
              </div>
            </div>
            
            <Button 
              type="button"
              onClick={handleTestLogin}
              className="w-full bg-orange-500 hover:bg-orange-600" 
              data-testid="test-login-btn"
            >
              🔓 Test Girişi (Formu Doldur)
            </Button>
          </form>
          
          <div className="mt-4 text-center">
            <a href="/login" className="text-sm text-purple-400 hover:text-purple-300">
              ← Normal kullanıcı girişi
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}